import { getFunctionsBaseUrl, type RuntimeEnv } from "./config";

export type HandoffRedemption = {
  firebaseCustomToken: string;
  expiresAt: number;
};

export type HandoffRedeemer = {
  redeem(code: string): Promise<HandoffRedemption>;
};

export function createServerHandoffRedeemer(env: RuntimeEnv): HandoffRedeemer {
  const baseUrl = getFunctionsBaseUrl(env);
  if (!baseUrl) {
    return {
      async redeem() {
        throw new Error("Functions base URL is not configured.");
      }
    };
  }

  return {
    async redeem(code) {
      const response = await fetch(`${baseUrl.replace(/\/$/, "")}/redeemAccountingHandoff`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code })
      });
      if (!response.ok) {
        throw new Error(`handoff_redemption_failed_${response.status}`);
      }
      const payload = (await response.json()) as Partial<HandoffRedemption>;
      if (!payload.firebaseCustomToken || typeof payload.expiresAt !== "number") {
        throw new Error("malformed_handoff_response");
      }
      return {
        firebaseCustomToken: payload.firebaseCustomToken,
        expiresAt: payload.expiresAt
      };
    }
  };
}

export function createMockHandoffRedeemer(): HandoffRedeemer {
  return {
    async redeem() {
      return {
        firebaseCustomToken: "mock-custom-token",
        expiresAt: Date.now() + 90_000
      };
    }
  };
}
